
import { defineComponent, ref, reactive } from 'vue'
import { FormInstance, FormRules, ElNotification } from "element-plus";
import AcrdService from '@/core/services/AcrdService';
import { errManager } from "@/core/config/Tools";
import { useI18n } from "vue-i18n/index";

export default defineComponent({
    name: "ModalItinerario",
    props: {
        rowSelected: {
            type: Object,
            required: true,
            default: {}
        }
    },

    emits: ["resItinerario"],
    setup( props, { expose, emit }) {
        const { t } = useI18n();
        const isModalVisible = ref(false);
        const loaderIti = ref(false)
        const formRef = ref<FormInstance>()
        const formIti = reactive(<any>{
            idacreditation: 0,
            status: false,
            aerolinea: null,
            vuelo: null,
            fecha: null,
            hora: null,
            aerolineaf: null,
            vuelof: null,
            fechaf: null,
            horaf: null,
            fecha1: null,
            fecha2: null
        })
        const rules = reactive<FormRules>({})


        const openModal = () => {
            isModalVisible.value = true;
        };

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            await formEl.validate((valid, fields) => {
                if (valid) {
                    onSave()
                }

            });
        };

        const onOpen = () => {
            //resetForm(formItiRef.value)
            //Object.assign(formIti, initialFormIti);
            /*
            for (const key in initialFormIti) {
                formIti[key] = initialFormIti[key];
            }
            */
            //console.log(formIti)
            //Object.assign(formIti, ...{initialFormIti})
        }

        const onOpened = () => {
            getItinerario();
        }

        const onClosed = () => {
            
            // Resetea de forma correcta
            /*
            for (const key in initialFormIti) {
                formIti[key] = initialFormIti[key];
            }
            */
           
            /*
            Object.keys(formIti).forEach(key => {
                delete formIti[key as keyof typeof formIti];
            });
            */
            Object.keys(formIti).forEach(key => delete formIti[key]);

            Object.assign(formIti, {
                idacreditation: 0,
                status: false,
                aerolinea: '',
                vuelo: '',
                fecha: '',
                hora: '',
                aerolineaf: '',
                vuelof: '',
                fechaf: '',
                horaf: '',
                fecha1: '',
                fecha2: ''
            });

            resetForm(formRef.value);
            //Object.keys(formIti).forEach(key => delete formIti[key]);
            
        }

        const getItinerario = async() => {
            loaderIti.value = true
            await AcrdService.getAcreditation(props.rowSelected.idacreditation, 'itinerario')
            .then((res)=>{
                if(res.data.itinerario){
                    Object.assign(formIti, res.data.itinerario)
                    formIti.idacreditation = props.rowSelected.idacreditation
                } else {
                    formIti.idacreditation = props.rowSelected.idacreditation
                }
               
                loaderIti.value = false
            }).catch(({response})=>{
                loaderIti.value = false
                errManager(response)
            })
        }

        const onSave = () => {
            loaderIti.value = true;
            AcrdService.options("itinerario", formIti)
                .then((res) => {
                    loaderIti.value = false;
                    ElNotification(res.data);
                    if (res.data.status == 'success') {
                        isModalVisible.value = false
                    }
                    emit("resItinerario", res.data)
                }).catch(({ response }) => {
                    loaderIti.value = false
                    errManager(response)
                }).finally(() => {
                    loaderIti.value = false
                })
        }

         

        const resetForm = (formEl: FormInstance | undefined) => {
            if(!formEl) return;
            formEl.resetFields();
        }

        return {
            t,
            isModalVisible,
            formIti,
            loaderIti,
            formRef,
            rules,
            //methods
            submitForm,
            resetForm,
            onOpen,
            onOpened,
            onClosed,
            openModal

        }

    },
})
